import { DefaultOptionType } from 'antd/lib/select'

import { SelectOptionModel } from '@/domain/model/select'

const normalizeText = (text: string): string => {
  return text
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '') // Remove acentos
    .replace(/[^a-z0-9\s]/gi, '') // Remove caracteres especiais, mantendo apenas letras, números e espaços
    .toLowerCase()
}

export const getFilterOption = (
  input: string,
  option: SelectOptionModel | DefaultOptionType | undefined
) => {
  const label = normalizeText(String(option?.label ?? ''))
  const searchBy = normalizeText(String(option?.searchBy ?? ''))
  const searchText = normalizeText(input)
  const searchWords = searchText.split(' ').filter((word) => word.length)

  return searchWords.every(
    (word) => label.includes(word) || searchBy.includes(word)
  )
}
